import React, { useState, useEffect } from 'react';
import './index.css'; 

import AboutMe from './components/AboutMe';
import Education from './components/Education';
import Experience from './components/Experience';
import Skills from './components/Skills';
import Contact from './components/Contact';

function App() {
  // Dark mode state implementation
  const [darkMode, setDarkMode] = useState(false);

  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900 text-gray-900 dark:text-gray-100 font-sans transition-colors duration-300">
      
      {/* Navigation & Header */}
      <header className="sticky top-0 z-50 flex flex-col md:flex-row justify-between items-center py-6 px-10 bg-blue-600 dark:bg-gray-800 text-white shadow-lg transition-colors duration-300">
        <h1 className="text-3xl font-bold tracking-wider uppercase mb-4 md:mb-0">My Portfolio</h1>
        <nav className="flex space-x-4 items-center">
          <a href="#about" className="hover:text-blue-200 transition">About</a>
          <a href="#education" className="hover:text-blue-200 transition">Education</a>
          <a href="#experience" className="hover:text-blue-200 transition">Experience</a>
          <a href="#contact" className="hover:text-blue-200 transition">Contact</a>
          
          {/* Dark Mode Toggle Button */}
          <button 
            onClick={() => setDarkMode(!darkMode)}
            className="ml-4 p-2 bg-white/20 hover:bg-white/30 rounded-full transition-all"
            title="Toggle Dark Mode"
          >
            {darkMode ? '☀️' : '🌙'}
          </button>
        </nav>
      </header>

      {/* Main Content Area */}
      <main className="max-w-5xl mx-auto p-6">
        <AboutMe />
        <Education />
        <Experience />
        <Skills />
        <Contact />
      </main>

      {/* Footer */}
      <footer className="text-center py-6 text-gray-500 dark:text-gray-400 text-sm">
        <p>&copy; {new Date().getFullYear()} Final Project Portfolio. Built with React & Tailwind.</p>
      </footer>
    </div>
  );
}

export default App;